class LocalNumbers extends HTMLElement {
  static get observedAttributes() { return ['numbers-required']; }

  attributeChangedCallback(name, ov, val) {
    switch (name) {
      case 'numbers-required':
        this.numbers_required = Number(val);
    }
  }

  constructor() {
    super();
    this.npanxx_index = 0;
    this.npanxx_selects;
    this.value = [];
  }
  connectedCallback() {

    this.innerHTML = `
    <style>
      .scrollable_npanxx {     
        max-height: 240px;
        overflow: scroll;
        scroll-behavior: auto;
      }

      #npanxx_selects {
        position: relative;
      }

      #npanxx_selects .scrollable_npanxx {
        position: absolute;
        top: -80px;
        right: 70px;
      }

      #npanxx_selects .scrollable_npanxx .form-group {
        margin-bottom: 10px;
      }

      #npanxx_selects select.form-control {
        margin-bottom: 0;
      }

      #npanxx-refresh {
        font-weight: bold;
        position: absolute;
        top: 150px;
        left: 65px;
      }

      #npanxx-refresh:hover {
        text-decoration: none;
        cursor: pointer;
      }
    </style>
    <label>Local Numbers</label>
    <div class="row">
      <div class="col-sm-6 no-gutters" id="local-num-input">
        <input id="npanxx-input" type="tel" maxlength="6" class="form-control" data-cy="npanxx-input" placeholder="(123) 444-XXXX">
        <div class="col" id="availability"></div>
        </div>
      <div class="col-sm-5 col-sm-offset-1 hidden" id="npanxx-container">
        <div id="npanxx_selects" data-cy="npanxx_selects"></div>
        <a class="pull-right" id="npanxx-refresh" data-cy="npanxx-refresh"> Refresh results</a>
      </div>
    </div>
    <span id="campaign-warning" style="color:orange;"></span>
    `;

    this.querySelector('#npanxx-refresh').addEventListener('click', function() {
      this.refreshOptions();
    }.bind(this));

    this.init();
  }
 
  init() {
    let numField = this.querySelector("#npanxx-input")
    numField.addEventListener("keyup", async function(e) {
      this.valid=false
      // ajax to get available number count
      this.querySelector("input").classList.remove("error");
      this.querySelector("#availability").innerHTML = '<img src="/assets/loaders/default.gif"/>';
      this.querySelector("#npanxx_selects").innerHTML = "";
      let request = e.target.value.replace(/\D/g,'');
      request.length < 6 ? this.querySelector("#availability").classList.add("hidden") : this.querySelector("#availability").classList.remove("hidden");
      request.length < 6 ? this.querySelector("#npanxx-container").classList.add("hidden") : this.querySelector("#npanxx-container").classList.remove("hidden");
      // let numRequired = 1500;
      let numRequired = this.numbers_required;
      if(request.length == 6) {
        let res = await fetch(`/admin/campaigns/local_number_search?number=${request}&quantity=${numRequired}`);
        // let res = await fetch(`/local_numbers.json`);
        this.availableNums = await res.json();

        // If only one available number group is returned that is all we have to work with. Otherwise user can select which NPANXX they want.
        if(this.availableNums.length > 0) {
          this.querySelector("#availability").innerHTML = "";
          this.querySelector("#availability").style.display = "none";
          this.npanxx_selects = this.availableNums.map(function(availNum) { 

          let options = "";
          for(let i=0; i<=numRequired && i<=availNum.quantityAvailable; i++) {
            options += `<option value=${i}>${i}</option>`
          }
          let split_npa_nxx = availNum.npanxx.match(/^(\d{3})(\d{3})$/);
          return `<div class="form-inline">
            <div class="form-group">
              <label style="margin-right:2em">(${split_npa_nxx[1]}) ${split_npa_nxx[2]}-XXXX</label>
              <select class="form-control" data-npanxx="${availNum.npanxx}">${options}</select>
            </div>
          </div>` } )//.join("");
          this.npanxx_index = 0;
          // let npanxx_portion = this.npanxxPortion(this.npanxx_selects, 0);
          this.refreshOptions();
          // this.querySelector("#npanxx_selects").innerHTML = `<label>Select numbers you want to use: <span class="msg"></span></label>
          // <div class="scrollable_npanxx">
          //   ${npanxx_selects}
          // </div>`;
          this.querySelectorAll("#npanxx_selects select").forEach(function(element) {
            element.addEventListener("change", function() {
              this.validateSelections()
            }.bind(this));
          }.bind(this));
        } else {
          this.querySelector("#availability").style.display = "initial";
          this.querySelector("#availability").innerHTML = '<span style="color:red;">No numbers found</span>';
        }

        // change availablity span based on number
        /*this.querySelector("#availability").innerHTML = this.availableNums.quantity >= numRequired ? `<span style="color:green;">${this.availableNums.quantity} numbers found</span>` :
                                                        this.availableNums.quantity == 0 ? `<span style="color:red;">No numbers found</span>` :
                                                        this.availableNums.quantity < numRequired ? `<span style="color:orange;">Only ${this.availableNums.quantity} numbers found</span>` : "";
        this.querySelector("#campaign-warning").innerHTML = this.availableNums.quantity < numRequired && this.availableNums.quantity != 0 ? `If you continue only ${this.availableNums.quantity} campaigns will be created` : "";
        console.log(this.availableNums.quantity)*/
      }
    }.bind(this));

    $('.campaign_toll_free').on('switchChange.bootstrapSwitch', function(event, state) {
      state ? this.classList.add("hidden") : this.classList.remove("hidden")
    }.bind(this));

    $("#npanxx-input").mask('(999) 999-XXXX')
  }

  isValid() {
    if(!this.valid) this.querySelector("input").classList.add("error");
    return this.valid;
  }
  
  reset() {
    this.valid = false;
    this.querySelector("input").classList.remove("error");
    this.querySelector("input").value = "";
    this.querySelector("#npanxx_selects").innerHTML = "";
    this.value = [];
  }

  validateSelections() {
    this.valid = false;
    let selectedNumbersCount = 0;
    this.value = [];
    for(let i=0; this.querySelectorAll("#npanxx_selects select").length > i; i++) {
      let npanxx_val = parseInt(this.querySelectorAll("#npanxx_selects select")[i].value)
      if( npanxx_val > 0) {
        this.value.push({"npanxx": this.querySelectorAll("#npanxx_selects select")[i].dataset.npanxx, "qtyRequired": npanxx_val})
        selectedNumbersCount += npanxx_val;
      }
    }
    if(selectedNumbersCount > 0) {
      this.valid = true;
      let numRequired = this.numbers_required;
      if(selectedNumbersCount < numRequired) {
        this.querySelector("#npanxx_selects span.msg").innerHTML = `<span style="color:orange;">Only ${selectedNumbersCount} numbers selected</span>`
      } else if(selectedNumbersCount > numRequired) {
        this.valid = false;
        this.querySelector("#npanxx_selects span.msg").innerHTML = `<span style="color:orange;">Too many numbers selected</span>`
      } else {
        this.querySelector("#npanxx_selects span.msg").innerHTML = "";
      }
    }
  }

  // npanxxPortion(options, index) {
  //   let npanxx_options = [];
  //   for(let i = this.index; i < this.index+5; i++) {
  //     npanxx_options.push(options[i])
  //     console.log(i)
  //     console.log(npanxx_options)
  //   }
  //   return npanxx_options
  // }

  refreshOptions() {
    let npanxx_options = [];
    for(let i = this.npanxx_index; i < this.npanxx_index+5; i++) {
      this.npanxx_selects[i] ? npanxx_options.push(this.npanxx_selects[i]) : null
    }
    this.querySelector("#npanxx_selects").innerHTML = `<label style="position: absolute; top: -119px; right: 70px;">Select numbers you want to use: <br><span class="msg pull-right"></span></label>
          <div class="scrollable_npanxx">
            ${npanxx_options.join("")}
          </div>`;
    this.npanxx_index < this.npanxx_selects.length - 5 ? this.npanxx_index += 5 : this.npanxx_index = 0;
    this.querySelectorAll("#npanxx_selects select").forEach(function(element) {
      element.addEventListener("change", function() {
        this.validateSelections()
      }.bind(this));
    }.bind(this));
  }

}

customElements.define("local-numbers", LocalNumbers)